export const administrationAccountsHeadOfficeRsc = {
    template: require('./administration-accounts-head-offices-rsc.html'),
    controller: 'AdministrationAccountsHeadOfficeRscController'
};
